module.exports = __webpack_public_path__ + "img/qr_02.164311af.jpg";